import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.function.bind";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import React, { Component } from 'react';
import { elementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import style from './tabs.module.less';
/**
 * ControlledTabs let the consumer decide which tab the user is currently viewing.
 */

var ControlledTabs = /*#__PURE__*/function (_Component) {
  _inherits(ControlledTabs, _Component);

  var _super = _createSuper(ControlledTabs);

  function ControlledTabs(props) {
    var _this;

    _classCallCheck(this, ControlledTabs);

    _this = _super.call(this, props);
    _this.resetUnderline = _this.resetUnderline.bind(_assertThisInitialized(_this));
    _this.debouncedResetUnderline = debounce(_this.resetUnderline, 100);
    return _this;
  }

  _createClass(ControlledTabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Note: this is a hack to fix the "flooded underline"
      // bug where the underline spans multiple tabs on
      // initial mount.
      // This delay should be imperceptible
      // to users; 180ms was chosen through
      // approximate manual testing.
      setTimeout(function () {
        _this2.resetUnderline();
      }, 180); // Reset the underline width on window resize

      window.addEventListener('resize', this.debouncedResetUnderline);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resetUnderline();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedResetUnderline);
    }
  }, {
    key: "resetUnderline",
    value: function resetUnderline() {
      var activeTab = this["tab".concat(this.props.activeTabIndex)];

      if (activeTab) {
        var transform = "translate3d(".concat(activeTab.offsetLeft, "px, 1px, 0px)"); // @TODO Use `transform: scaleX()` instead of width so the css
        // transition is gpu accelerated.
        // https://www.smashingmagazine.com/2016/12/gpu-animation-doing-it-right/

        this.underlineRef.style.width = "".concat(activeTab.offsetWidth, "px"); // Cover all our bases

        this.underlineRef.style.transform = transform;
        this.underlineRef.style.webkitTransform = transform;
        this.underlineRef.style.mozTransform = transform;
        this.underlineRef.style.msTransform = transform;
        this.underlineRef.style.oTransform = transform;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = React.Children.toArray(this.props.children).filter(function (child) {
        return child;
      }); // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration

      var hasMarginBetweenTabsAndContent = this.props.hasMarginBetweenTabsAndContent;
      var scrollContainerClass = classNames(style.scrollContainer, hasMarginBetweenTabsAndContent && style.scrollContainerMarginBtm);
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.className
      }, /*#__PURE__*/React.createElement("div", {
        className: scrollContainerClass
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames([style.tabsList, _defineProperty({}, style.singleTab, children.length === 1)])
      }, /*#__PURE__*/React.createElement("div", {
        className: style.tabsContainer
      }, children.map(function (child, index) {
        return child.props.label && /*#__PURE__*/React.createElement("div", {
          key: child.props.label,
          ref: function ref(el) {
            _this3["tab".concat(index)] = el;
          },
          className: style.tabWrapper
        }, /*#__PURE__*/React.cloneElement(child, {
          onClick: function onClick() {
            if (_this3.props.activeTabIndex !== index) {
              if (!_this3.props.disableTracking) {
                elementInteraction(_objectSpread({
                  interactionType: 'CLICK',
                  sectionCategory: _this3.props.id,
                  elementContent: child.props.label,
                  elementName: 'tab',
                  elementPosition: index
                }, child.props.trackingProps));
              } // horizontally scroll tab into view to ensure tab is clearly selected on initial render


              var tabEl = _this3["tab".concat(index)];

              if (tabEl.scrollIntoView) {
                tabEl.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'center'
                });
              }

              child.props.onTabClick();

              _this3.props.onActiveTabChange(index);
            }
          },
          active: index === _this3.props.activeTabIndex
        }));
      })), /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this3.underlineRef = el;
        },
        className: style.underline
      }))), /*#__PURE__*/React.createElement("div", null, children.map(function (child, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: child.props.label,
          className: classNames(style.tabContent, _defineProperty({}, style.hidden, _this3.props.activeTabIndex !== index))
        }, _this3.props.rememberState || _this3.props.activeTabIndex === index ? child.props.children : null);
      })));
    }
  }]);

  return ControlledTabs;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


ControlledTabs.displayName = 'ControlledTabs';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types'); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  ControlledTabs.propTypes = {
    /** set the current activeTabIndex which starts at 0 */
    activeTabIndex: PropTypes.number.isRequired,

    /** The individual tabs to generate - should be <Tab> components */
    children: PropTypes.node,

    /** Class name(s) to apply to the component */
    className: PropTypes.string,

    /** Flag to disable tracking that is mainly for use when you don't want the component
        to cause any side effects (Storybook, NDS Style Guide, testing, etc). Should not
        be set in a practical use case. */
    disableTracking: PropTypes.bool,

    /** This id will be used for tracking purposes as the `sectionCategory` */
    id: PropTypes.string,

    /** function to set the current active tab */
    onActiveTabChange: PropTypes.func.isRequired,

    /** If true, the tab content will remember its state when switching tabs.
     Defaults to true */
    rememberState: PropTypes.bool
  };
} // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


ControlledTabs.defaultProps = {
  className: null,
  children: null,
  disableTracking: false,
  id: '',
  rememberState: true
};
export default ControlledTabs;